import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const AgendaIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 25 25">
    <svg width="29" height="21" viewBox="0 0 29 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.1539 3.25463H18.72C18.7992 3.25463 18.8634 3.19282 18.8634 3.11649V2.70149C18.8634 2.62515 18.7992 2.5632 18.72 2.5632H10.1539C10.0747 2.5632 10.0107 2.62515 10.0107 2.70149V3.11649C10.0107 3.19282 10.0747 3.25463 10.1539 3.25463Z" fill="black" />
      <mask
        id="mask0_117_18"
        style={{
          maskType: 'luminance',
        }}
        maskUnits="userSpaceOnUse"
        x="4"
        y="2"
        width="21"
        height="18"
      >
        <path d="M4.01279 2.56161H24.9872V19.9445H4.01279V2.56161Z" fill="white" />
      </mask>
      <g mask="url(#mask0_117_18)">
        <path d="M22.757 19.2587H6.24316C5.40697 19.2587 4.72905 18.6042 4.72905 17.7968V8.06532H24.271V17.7968C24.271 18.6042 23.5932 19.2587 22.757 19.2587ZM22.757 2.56339H21.1553C21.0762 2.56339 21.0122 2.62534 21.0122 2.70181V3.11667C21.0122 3.193 21.0762 3.25495 21.1553 3.25495H22.757C23.5922 3.25495 24.271 3.91049 24.271 4.71827V7.37375H4.72905V4.71827C4.72905 3.91049 5.408 3.25495 6.24316 3.25495H7.71862C7.79768 3.25495 7.86184 3.193 7.86184 3.11667V2.70181C7.86184 2.62534 7.79768 2.56339 7.71862 2.56339H6.24316C5.01418 2.56339 4.01279 3.53024 4.01279 4.71827V17.7968C4.01279 18.9812 5.01654 19.9503 6.24316 19.9503H22.757C23.9836 19.9503 24.9874 18.9812 24.9874 17.7968V4.71827C24.9874 3.53024 23.986 2.56339 22.757 2.56339Z" fill="black" />
      </g>
      <path d="M8.93624 4.93797C9.29157 4.93797 9.58082 4.65983 9.58082 4.31547V1.84399C9.58082 1.49963 9.29157 1.2215 8.93624 1.2215C8.57958 1.2215 8.29166 1.49963 8.29166 1.84399V4.31547C8.29166 4.65983 8.57958 4.93797 8.93624 4.93797Z" fill="black" />
      <mask
        id="mask1_117_18"
        style={{
          maskType: 'luminance',
        }}
        maskUnits="userSpaceOnUse"
        x="19"
        y="1"
        width="2"
        height="4"
      >
        <path d="M19.2578 1.05002H20.6172V4.77603H19.2578V1.05002Z" fill="white" />
      </mask>
      <g mask="url(#mask1_117_18)">
        <path d="M19.9376 4.76777C20.293 4.76777 20.5824 4.48821 20.5824 4.14527V1.67237C20.5824 1.32929 20.293 1.05002 19.9376 1.05002C19.581 1.05002 19.2932 1.32929 19.2932 1.67237V4.14527C19.2932 4.48821 19.581 4.76777 19.9376 4.76777Z" fill="black" />
      </g>
    </svg>
  </SvgIcon>
);
export default AgendaIcon;
